import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M16.805 38.754V5.625h-3v33.129l-5.193-5.193-2.121 2.121 8.814 8.814 8.813-8.814-2.121-2.121zm24.704-17.282-8.814-8.813-8.813 8.813 2.121 2.121 5.192-5.192v13.244h3V18.401l5.193 5.192z" }) }) })
});
export default SvgSortDown;
